export default __webpack_public_path__ + "static/media/icon-support-chat-active.0c699cae.svg";